import { styled } from "@mui/material";

export const StyledTitle = styled('p')(() => ({
    padding: '0 32px',
    color: "rgb(21, 41, 53)",
    fontSize: "20px",
    fontFamily: "Roboto",
    letterSpacing: "0.15px",
    lineHeight: "20px",
    fontWeight: 'bold'
}));
